var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isShowSelect,
            expression: "isShowSelect",
          },
        ],
        staticClass: "mask",
        on: {
          click: function ($event) {
            _vm.isShowSelect = !_vm.isShowSelect
          },
        },
      }),
      _vm._v(" "),
      _c(
        "el-popover",
        {
          attrs: {
            placement: "bottom-start",
            width: _vm.width,
            trigger: "manual",
          },
          on: { hide: _vm.popoverHide },
          model: {
            value: _vm.isShowSelect,
            callback: function ($$v) {
              _vm.isShowSelect = $$v
            },
            expression: "isShowSelect",
          },
        },
        [
          _c("el-tree", {
            ref: "tree",
            staticClass: "common-tree",
            style: _vm.style,
            attrs: {
              data: _vm.data,
              props: _vm.defaultProps,
              "show-checkbox": _vm.multiple,
              "node-key": _vm.nodeKey,
              "check-strictly": _vm.checkStrictly,
              "default-expand-all": "",
              "expand-on-click-node": false,
              "default-checked-keys": _vm.defaultCheckedKeys,
              "highlight-current": true,
            },
            on: {
              "node-click": _vm.handleNodeClick,
              "check-change": _vm.handleCheckChange,
            },
          }),
          _vm._v(" "),
          _c(
            "el-select",
            {
              ref: "select",
              staticClass: "tree-select",
              style: _vm.selectStyle,
              attrs: { slot: "reference", multiple: _vm.multiple },
              nativeOn: {
                click: function ($event) {
                  _vm.isShowSelect = !_vm.isShowSelect
                },
              },
              slot: "reference",
              model: {
                value: _vm.selectedData,
                callback: function ($$v) {
                  _vm.selectedData = $$v
                },
                expression: "selectedData",
              },
            },
            _vm._l(_vm.options, function (item) {
              return _c("el-option", {
                key: item.value,
                attrs: { label: item.label, value: item.value },
              })
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }